module.exports = __webpack_public_path__ + "img/serv-cursos.5618ea5c.jpg";